

export const switchGroup = (groupId = null) => {
    return async (dispatch, getState) => {
        let group = {
            ...getState().instructorReducer.group,
            current: groupId
        }

        const handleDispatch = () => dispatch({
            type: 'SWITCH_GROUP',
            payload: {
                group
            }
        })

        handleDispatch()
    }
}

export const refreshGroups = () => {
    return async (dispatch, getState) => {

        let group = {
            ...getState().instructorReducer.group,
            refresh: new Date(),
        }

        const handleDispatch = () => dispatch({
            type: 'REFRESH_GROUPS',
            payload: {
                group
            }
        })

        handleDispatch()
    }
}

export const switchTopic = (topicId = null) => {
    return async (dispatch, getState) => {
        let topic = {
            ...getState().instructorReducer.topic,
            current: topicId
        }

        const handleDispatch = () => dispatch({
            type: 'SWITCH_TOPIC',
            payload: {
                topic
            }
        })

        handleDispatch()
    }
}

export const filterByStudent = id => {
    return async (dispatch, getState) => {
        let student = {
            ...getState().instructorReducer.student,
            id
        }

        const handleDispatch = () => dispatch({
            type: 'FILTER_BY_STUDENT',
            payload: {
                student
            }
        })

        handleDispatch()
    }
}

export const sortStudentsByWrongAnswers = ids => {
    return async (dispatch, getState) => {
        let student = {
            ...getState().instructorReducer.student,
            sortByIds: ids
        }
        
        const handleDispatch = () => dispatch({
            type: 'SORT_STUDENTS_BY_WRONG_ANSWERS',
            payload: {
                student
            }
        })

        handleDispatch()
    }
}
